import styled from 'styled-components';

export const VideoContainer = styled.div`
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9; /* Ensures the proper aspect ratio */

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0; /* Removes iframe border */
  }
`;

export const VideoContainerDirect = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    padding-bottom: 4px;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export const FloatingPiPWrapper = styled.div`
  position: fixed;
  z-index: 1200;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  background: #000;
  bottom: 16px;
  right: 16px;
  width: 360px;
  max-width: 50vw;
  aspect-ratio: 16 / 9;

  &[data-fullscreen='true'] {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    aspect-ratio: auto;
  }
  &:hover .pip-controls {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const PiPControls = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 4px;
  z-index: 2600;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
  opacity: 0;
  pointer-events: none;
  transition: opacity 120ms ease-in-out;

  button {
    font-size: 10px;
    padding: 2px 6px;
    height: 22px;
  }
`;

export const PiPContent = styled.div`
  position: absolute;
  top: 28px;
  left: 0;
  right: 0;
  bottom: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;
